// Generated by CoffeeScript 2.7.0
var Admin__YetAnotherWorkflow__JourneysController,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

import {
  JourneysTableForAdmin
} from 'trunks/vue/admin/compositions/datable_table/journeys_table.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import AssignmentConcern from 'trunks/controllers/concerns/yaw/assignments.js';

import WebAdmin__AssignmentConcern from 'trunks/controllers/concerns/web_admin/yaw/assignments.js';

import {
  newAbortModal
} from 'trunks/vue/admin/compositions/yet_another_workflow/abort_modal.js';

import FlowMoreOperations from './concerns/flow_more_operations.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

export default Admin__YetAnotherWorkflow__JourneysController = (function() {
  class Admin__YetAnotherWorkflow__JourneysController extends Skylark.App.BaseController {
    constructor() {
      super(...arguments);
      this._doRepairFlow = this._doRepairFlow.bind(this);
    }

    index() {
      var flow;
      this.__toggleNavMenu();
      flow = new Skylark.App.Model.YetAnotherWorkflow.Flow(_.extend(this.getVars('flow'), {
        graphs: this.getVars('graphs')
      }));
      return new JourneysTableForAdmin({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('js_journeys_container'),
        propsData: {
          fieldable: {
            fields: flow.getAllFieldsInFlow()
          },
          datableGID: flow.gid,
          totalRecordCount: this.getVars('total_count')
        }
      }).$on('selectedRowsChanged', (journey_ids) => {
        return this.journeyIds = journey_ids;
      });
    }

    showAssignment(journey_id) {
      var abort_btn;
      abort_btn = DomMaster.find('.abort-journey-btn');
      if (abort_btn.node) {
        abort_btn.node.addEventListener('click', (event) => {
          this.abortModal = new newAbortModal();
          return this.abortModal.$on('ensureClicked', (settings) => {
            return this._abortJourney(journey_id, settings);
          });
        });
      }
      this._initPreviewSignature();
      this.overlay_el = DomMaster.find('.assignment-overlay');
      this.journey_id = journey_id;
      this.attachments = [];
      this._initAttachmentsAndBindEvents();
      return this._bindBatchDownloadEvents(journey_id);
    }

    _doRepairFlow(el, flow_id) {
      boundMethodCheck(this, Admin__YetAnotherWorkflow__JourneysController);
      return el.node.proxy('click', '.js-repair-flow', (event) => {
        var confirmButtonText, message, request_disabeld;
        request_disabeld = this.journeyIds.length <= 0;
        message = '如果发现流程导出的字段有缺失或处理流程记录时出现异常，请尝试此功能';
        confirmButtonText = '修复';
        if (request_disabeld) {
          message = '没有选中任何记录，请重新选择';
          confirmButtonText = '确定';
        }
        return newConfirm({
          icon: '<i class="slp-warning-circle"></i>',
          title: "修复流程",
          message: message,
          confirmButtonText: confirmButtonText,
          type: "danger"
        }).$on('ensureClicked', () => {
          if (request_disabeld) {
            return;
          }
          return Skylark.Libs.Ajax.patch(`/admin/yet_another_workflow/flows/${flow_id}/repair`, {
            contentType: 'application/json; charset=utf-8',
            data: {
              journey_ids: this.journeyIds
            },
            success: function() {
              return Skylark.Bridge.newAlertify('修复流程成功，请耐心等待', {
                type: 'success'
              });
            }
          });
        });
      });
    }

    _abortJourney(journey_id, settings) {
      return Skylark.Libs.Ajax.get(`/admin/yet_another_workflow/flows/${this.getVars('flow').id}/journeys/${journey_id}/processing_moment`, {
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          return Skylark.Libs.Ajax.patch(`/admin/yet_another_workflow/flows/${this.getVars('flow').id}/journeys/${journey_id}/moments/${data.id}`, {
            contentType: 'application/json; charset=utf-8',
            responseType: 'json',
            data: {
              moment: {
                status: 'aborted',
                comment: settings.value
              }
            },
            success: () => {
              return Skylark.Libs.Ajax.get(`/admin/yet_another_workflow/flows/${this.getVars('flow').id}/journeys/${journey_id}`, {
                contentType: 'application/json; charset=utf-8',
                responseType: 'script'
              });
            },
            error: function(xhr, status, error) {
              return Skylark.Bridge.newAlertify('终止失败', {
                type: 'error'
              });
            }
          });
        }
      });
    }

    _concernedAttachmentsUrl() {
      var _path;
      _path = `/yet_another_workflow/journeys/${this.journey_id}/concerned_attachments.json`;
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(_path);
    }

  };

  Admin__YetAnotherWorkflow__JourneysController.include(AssignmentConcern, WebAdmin__AssignmentConcern);

  Admin__YetAnotherWorkflow__JourneysController.include(FlowMoreOperations, ToggleNavMenuAction);

  return Admin__YetAnotherWorkflow__JourneysController;

}).call(this);
